// extracted by mini-css-extract-plugin
export default {"companyRow":"Testing_companyRow__Lpbtx","productRow":"Testing_productRow__40Och"};